import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Form, Input, Popconfirm, Table, Checkbox } from 'antd';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios'; 
import "../style.scss";
import "../riot_admin.scss";
import SideBar from "../sidebar";
import Header from "../Header";
const { Search } = Input;
const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};
const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
  }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
  
    useEffect(() => {
      if (editing && inputRef.current) {
        inputRef.current.focus();
      }
    }, [editing]);
  
    const toggleEdit = () => {
      setEditing(!editing);
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    };
  
    const save = async () => {
      try {
        const values = await form.validateFields();
        toggleEdit();
        handleSave({
          ...record,
          ...values,
        });
      } catch (errInfo) {
        console.log('Save failed:', errInfo);
      }
    };
  
    let childNode = children;
  
    if (editable) {
      childNode = editing ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} is required.`,
            },
          ]}
        >
          {dataIndex === 'checkbox' ? (
            <Checkbox ref={inputRef} onClick={save} />
          ) : (
            <Input ref={inputRef} onPressEnter={save} onBlur={save} />
          )}
        </Form.Item>
      ) : dataIndex === 'checkbox' ? (
        <Checkbox onClick={toggleEdit} />
      ) : (
        <div
          className="editable-cell-value-wrap"
          style={{
            paddingRight: 24,
          }}
          onClick={toggleEdit}
        >
          {children}
        </div>
      );
    }
  
    return <td {...restProps}>{childNode}</td>;
  };
  
const AvailablePincodes = () => {
    const navigate = useNavigate();
  const [count, setCount] = useState(2);
  const [data, setData] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [selectedPincodes, setSelectedPincodes] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(true);
  
  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
  };
  const handleCheckboxChange = (pincodeid) => {
    // Toggle the value in sessionStorage
    const selectedPincodes = JSON.parse(sessionStorage.getItem('availabledPincodes')) || [];
    const index = selectedPincodes.indexOf(pincodeid);

    if (index !== -1) {
      selectedPincodes.splice(index, 1);
    } else {
      selectedPincodes.push(pincodeid);
    }

    sessionStorage.setItem('availabledPincodes', JSON.stringify(selectedPincodes));
    setSelectedPincodes(selectedPincodes);
  };
  const defaultColumns = [
    {
      title: '',
      dataIndex: 'checkbox',
      render: (_, record) => (
        <Checkbox
          onClick={() => handleCheckboxChange(record.pincodeid)} // handleCheckboxChange function added
        />
      ),
    },
    
    // {
    //   title: 'Pincode ID',
    //   dataIndex: 'pincodeid',
    //   width: '30%',
    //   editable: false, // Assuming 'pincodeid' is not editable
    // },
    {
      title: 'Pincode',
      dataIndex: 'pincode',
      editable: false,
    },
    // {
    //   title: 'Area',
    //   dataIndex: 'area',
    //   editable: true,
    // },
    {
      title: 'State',
      dataIndex: 'state',
      editable: false,
    },
    {
      title: 'Country',
      dataIndex: 'country',
      editable: false,
    },
  ];
  
  const handleAdd = () => {
    const newData = {
      key: count,
      name: `Edward King ${count}`,
      age: '32',
      address: `London, Park Lane no. ${count}`,
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };
  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
  };
  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    };
  });
  useEffect(() => {
    const fetchPincodeData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token'); // Assuming you store your token in localStorage
        if (!token) {
          // Redirect to the login page if the token is not present
          navigate('AdminLogin');
          return;
        }

        const response = await axios.put("https://api.starmallonline.com/api/v1/pincode/get", {}, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (response.status === 401 || response.status === 404) {
          // Redirect to the login page for 401 or 404 errors
          navigate('/AdminLogin');
          return; // Exit early to prevent further logic execution
        }

        setData(response.data);
        sessionStorage.removeItem('availabledPincodes');
      } catch (error) {
        console.error("Error fetching data:", error);
      }finally{
        setLoading(false);
      }
    };

    fetchPincodeData();
  }, [navigate]);
  const handleMakeUnAvailable = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        return;
      }

      const selectedPincodes = JSON.parse(sessionStorage.getItem('availabledPincodes')) || [];

      if (selectedPincodes.length === 0) {
        // No pincodes selected, show an alert or handle accordingly
        alert('Please select pincodes before making them available.');
        return;
      }

      // Create FormData
      const formData = new FormData();
        formData.append(`pincodeid`, selectedPincodes);

      const response = await axios.post(
        'https://api.starmallonline.com/api/v1/pincode/makenotavailable',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      // Handle the API response as needed
      console.log('Make Available API Response:', response.data);

      // Clear selected pincodes from sessionStorage after making them available
      sessionStorage.removeItem('availabledPincodes');
      window.location.reload();
      // You may also want to refresh the data after making pincodes available
      // Call fetchPincodeData or any relevant function here

    } catch (error) {
      console.error('Error making pincodes available:', error);
    }
  };
  const handleSearch = (value) => {
    setSearchText(value);
    const filteredData = data.filter(item => item.pincode.includes(value));
    setDataSource(filteredData);
  }
  return (
    <div>
        <div className="wrapper">
        <SideBar />
        <div className="ec-page-wrapper">
      <Header />
      <div className="ec-content-wrapper">
        <div className="content" style={{ marginTop: "50px" }}>
        <div className="breadcrumb-wrapper breadcrumb-wrapper-2 breadcrumb-contacts">
        <h1>Available Pincodes</h1>
            <p className="breadcrumbs">
            {selectedPincodes.length > 0 && (
          <button className="btn btn-primary" onClick={handleMakeUnAvailable} style={{ marginRight: '10px' }}>
            Make UnAvailable
          </button>
        )}
            <button className="btn btn-info">
              <Link to="/main-pincode" style={{ color: 'white', textDecoration: 'none' }}>Add Pincode</Link></button>
            </p>
          </div>
          <div style={{ marginBottom: '16px'}}>
            <Search
              placeholder='Search by Pincode'
              allowClear
              enterButton="Search"
              size='large'
              onSearch={handleSearch}
              style={{width:"300px"}}
              />
              </div>
              {loading  ? (
  <div className="container-fluied">
    <div className="row">
      <div className="muti-col-loader"></div>
    </div>
  </div>
) : (
      <Table
        components={components}
        rowClassName={() => 'editable-row'}
        bordered
        dataSource={searchText ? dataSource : data}
        columns={columns}
      />
)}
    </div>
    </div>
    </div>
    </div>
    </div>
  );
};
export default AvailablePincodes;